import styled, { css } from 'styled-components';

const headerHeight = 78;

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 0 40px 40px;
    height: calc(100vh - ${headerHeight}px);
    
    @media (max-width: ${theme.breakpoints.md}) {
      padding: 0;
    }

    @media (max-width: ${theme.breakpoints.sm}) {
      padding: 0 0 120px 0;
    }
  `}
`;


export const StyledContainer = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.neutral.highPure};
    border-radius: 24px;
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 24px;
  `}
`;

export const Image = styled.img`
  max-width: 200px;
  width: 100%;
`;

export const TitleRow = styled.div`
  ${() => css`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    min-width: 100%;
    padding: 24px 24px 40px;
  `}
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.bold}; 
    line-height: ${theme.v2.font.lineHeight.title};
    margin: 0px;
  `}
`;

export const SelectWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    & > div { 
      padding: 0px;
      border: 0px;
      & > div {
        padding: 0px;
      }
    }
`;

export const Content = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    min-height: 100%;
    min-width: 100%;
    padding: 30px;
`;

export const SecondTitle = styled.h3`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.bold}; 
    line-height: ${theme.v2.font.lineHeight.text};    
    margin: 24px 0px 0px;
    max-width: 364px;
    text-align: center;
  `}
`;

export const Description = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular}; 
    line-height: ${theme.v2.font.lineHeight.text};    
    margin: 6px 0px 0px;
    max-width: 364px;
    text-align: center;
  `}
`;

export const ButtonWrapper = styled.div`
    margin-top: 32px;
`;
